import { Course } from "../models/course";
import { CourseEnrollment } from "../models/course-enrollment";
import { get } from "./utils";

export const getCourses = async (url: string) => await get<Course[]>(url, true);
export const getCourseEnrollments = async (url: string) => await get<CourseEnrollment[]>(url);
export const getActiveCourseEnrollments = async (url: string) => await get<CourseEnrollment[]>(url, true);
